import { connect } from "react-redux";
import DownloadsItem from "./DownloadsItem";
import { getLessonById } from "../../selectors/lessonSelectors";

function mapStateToProps(state, { file }) {
  return {
    lesson: getLessonById(state, file?.lessonId),
  };
}

export default connect(mapStateToProps)(DownloadsItem);
